import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setPrPtMovedFromOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getPrPtMovedFromOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getPrPtMovedFromOptions])
    const { entity } = response
    yield put(setPrPtMovedFromOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPrPtMovedFromOptions() error: ${e}`))
  }
}
export function* getPrPtMovedFromOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPrPtMovedFromOptions)
}
